__turbopack_context__.v({
  "articles": "S7cu7a_articles",
  "filter-form": "S7cu7a_filter-form",
  "filters": "S7cu7a_filters",
  "pagination": "S7cu7a_pagination",
});
